// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { GlobalVehicleManagementAreaId } from './GlobalVehicleManagementAreaId'
import {
  GlobalVehicleManagementAreaNavigation,
  GlobalVehicleManagementAreaNavigationIcon,
} from './GlobalVehicleManagementAreaNavigation'
import { GlobalVehicleManagementAreaRoutes } from './GlobalVehicleManagementAreaRoutes'

const LazyGlobalVehicleManagementComponent = lazy(
  () => import('./GlobalVehicleManagementArea'),
)

const GlobalVehicleManagementComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyGlobalVehicleManagementComponent />
  </SuspenseLoadingWrapper>
)

export const GlobalVehicleManagementArea = {
  id: GlobalVehicleManagementAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_VEHICLE_MANAGEMENT,
  Icon: GlobalVehicleManagementAreaNavigationIcon,
  NavigationComponent: GlobalVehicleManagementAreaNavigation,
  route: {
    path: GlobalVehicleManagementAreaRoutes.route,
    component: GlobalVehicleManagementComponent,
  },
}
